var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoggedIn)?_c('div',{staticClass:"image-container"},_vm._l((_vm.allImages),function(image){return _c('img',{key:image.link,attrs:{"src":image.link}})}),0):_c('h2',[_vm._v(" Login in to get started!! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }